/* ==========================================================================
   By Madinah — note panier "cadeaux à préparer" (v4)
 
   Remplace assets/bm-cadeaux.js. Depuis la v4, les cadeaux ne sont plus
   ajoutés au panier ni au checkout (voir l'en-tête de
   snippets/bm-cadeaux-jauge.liquid : les remises automatiques cadeaux
   entraient en conflit avec les autres remises produit, ex. les promos
   sur les packs de Mudd — Shopify n'applique qu'une seule remise
   "Product" à la fois).
 
   Ce script se contente d'écrire un attribut de panier ("Cadeaux
   offerts") listant les cadeaux débloqués selon le montant du panier.
   Cet attribut :
   · est visible sur la page de détail de la commande et sur le bon de
     préparation (section "Additional details" / notes) ;
   · NE crée AUCUNE ligne de commande ;
   · NE décrémente PAS le stock automatiquement.
 
   Pour un vrai suivi de stock automatique, il faut ajouter les cadeaux à
   la COMMANDE (pas au panier) après paiement, via l'API Order Edit de
   Shopify (orderEditBegin / orderEditAddVariant / orderEditCommit),
   déclenchée par un webhook orders/create — ça décrémente le stock comme
   une vraie ligne vendue, sans jamais passer par le panier ni le
   checkout, donc sans re-créer le conflit de remises. C'est un petit
   projet à part (app privée + hébergement du webhook) : à faire quand
   vous voulez industrialiser ce suivi.
 
   À déposer dans assets/ puis appeler dans layout/theme.liquid, APRÈS
   bm-cart.js (remplace la ligne du script bm-cadeaux.js) :
   <script src="{{ 'bm-cadeaux-note.js' | asset_url }}"></script>
   ========================================================================== */
(function () {
  'use strict';
 
  var CLE = 'Cadeaux offerts';
  var dernierTexte = null;
 
  function lireConfig() {
    var noeud = document.querySelector('[data-bm-cadeaux-config]');
    if (!noeud) return [];
    try { return JSON.parse(noeud.textContent) || []; } catch (e) { return []; }
  }
 
  function texteCadeaux(cart) {
    if (!cart) return '';
    var paliers = lireConfig();
    if (!paliers.length) return '';
    var noms = [];
    paliers.forEach(function (p) {
      if (cart.total_price >= p.montant_c) noms.push(p.titre + ' (' + p.montant + ' €)');
    });
    return noms.join(' + ');
  }
 
  function racine() {
    return (window.BMCart && window.BMCart.racineRoutes()) || '/';
  }
 
  function synchroniser(cart) {
    var texte = texteCadeaux(cart);
    if (texte === dernierTexte) return;
    dernierTexte = texte;
    var attrs = {};
    attrs[CLE] = texte;
    fetch(racine() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }
 
  document.documentElement.addEventListener('cart:change', function (e) {
    if (!e.detail || !e.detail.cart) return;
    synchroniser(e.detail.cart);
  });
 
  function initial() {
    if (!window.BMCart) { setTimeout(initial, 50); return; }
    window.BMCart.lire().then(synchroniser).catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initial);
  } else {
    initial();
  }
})();